<template>
    <button-base styleType="success">
        <slot></slot>
    </button-base>
</template>
